import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface BibliaUpdateTarget {
  activityId: any;
  day: any;
}

@Injectable({
  providedIn: 'root'
})
export class ServicesBibliaService {
  //Observables se añade el signo $
  private $dataBiblia = new BehaviorSubject<any>(null);

  constructor() {}

  saveDataBliblia$(data: any): void {
    return this.$dataBiblia.next(data);
  }

  updateProperties(
    prop: any,
    value: any,
    targets: BibliaUpdateTarget[],
    numberFile: string,
    itineraryId: string,
    userName: string | null
  ) {
    const currentData = this.$dataBiblia.getValue() ?? [];
    const targetKeys = new Set(targets.map((target) => target.activityId));
    const now = new Date();

    const updatedData = currentData.slice();
    let changed = false;

    for (let i = 0; i < currentData.length; i++) {
      const item = currentData[i];
      if (
        item.day != null &&
        item.idItinerary === itineraryId &&
        item.fileNumber === numberFile &&
        targetKeys.has(item.idActivity)
      ) {
        updatedData[i] = {
          ...item,
          [prop]: value,
          dateActualizacion: now,
          usuarioOperador: userName
        };
        changed = true;
      }
    }

    if (changed) {
      this.$dataBiblia.next(updatedData);
    }

    return updatedData;
  }

  updateProperty(
    prop: any,
    value: any,
    id: any,
    day: any,
    numberFile: string,
    itineraryId: string,
    userName: string | null
  ) {
    return this.updateProperties(
      prop,
      value,
      [{ activityId: id, day }],
      numberFile,
      itineraryId,
      userName
    );
  }
}
